export default {
  toasts: {
    load_error: 'Nie udało się załadować konfiguracji płatności',
    rails_saved: 'Kanały płatności zapisane',
    gateway_registered: 'Bramka zarejestrowana',
    redact_failed: 'Nie udało się usunąć danych bramki',
    gateway_redacted: 'Dane bramki usunięte',
    sca_provisioned: 'Rejestracja 3DS2 utworzona',
    company_assigned: 'Restauracja przypisana',
    default_set: 'Ustawiono bramkę domyślną — nowe restauracje będą do niej przypisywane automatycznie',
    default_failed: 'Nie udało się ustawić domyślnej bramki',
    primary_switched: 'Bramka główna zmieniona na {{gateway}}',
    primary_switch_failed: 'Nie udało się zmienić głównej bramki',
  },
  custody: {
    title: 'Kto przetwarza płatności',
    description:
      'Decydowane jednorazowo, przy pierwszym zapisie kanału, i blokowane później: z własną bramką partner posiada środki; na koncie Adyen FoodAmigos to FoodAmigos posiada środki i wypłaca udział partnera co miesiąc.',
    options: {
      provider: 'Własna bramka partnera',
      platform: 'FoodAmigos przetwarza płatności',
    },
    locked_notice: 'Zablokowane na „{{custodian}}” przez konfigurację płatności — nie można tego zmienić.',
    pick_first: 'Najpierw wybierz, kto przetwarza płatności.',
    lock_confirm: {
      title: 'Zablokować płatności na rzecz „{{custodian}}”?',
      description:
        'Zapisanie teraz decyduje, kto przechowuje środki tego partnera, i nie można tego cofnąć — ani tutaj, ani przez wsparcie. Szynę płatności można jeszcze zmienić później; kto przetwarza płatności — już nie.',
      confirm: 'Zablokuj i zapisz',
    },
  },
  rails: {
    title: 'Kanał płatności',
    description:
      'Z jakiego procesora korzysta ten partner — tylko jeden naraz. Restauracje można przełączać wyłącznie na kanał wybrany tutaj, a kanału nie można zastąpić, dopóki restauracje wciąż na nim pobierają płatności.',
    save: 'Zapisz kanał',
    multiple_warning:
      'Ten partner nadal korzysta z więcej niż jednego kanału ({{rails}}). Zapisanie zachowa tylko ten wybrany powyżej; pozostałe zostaną usunięte, a zmiana zostanie odrzucona, jeśli którakolwiek restauracja wciąż pobiera płatności na jednym z nich.',
    options: {
      stripe: 'Stripe',
      adyen: 'Adyen',
      spreedly: 'Lokalna bramka przez Spreedly',
    },
    platform_stripe_unavailable: 'Stripe na kontach FoodAmigos nie jest jeszcze dostępny.',
    platform_custody_notice: 'Niedostępne, gdy płatności przetwarza FoodAmigos.',
    provider_custody_adyen_notice:
      'Niedostępne, gdy partner korzysta z własnej bramki płatności — Adyen jest kanałem przetwarzania płatności FoodAmigos.',
  },
  spreedly_section_title: 'Konfiguracja Spreedly',
  gateways: {
    title: 'Bramki',
    description: 'Własne konta PSP partnera. Całe obciążenie trafia do acquirera wybranej bramki.',
    register: 'Zarejestruj bramkę',
    empty: 'Brak zarejestrowanych bramek',
    columns: {
      gateway: 'Bramka',
      status: 'Status',
      sca: '3DS2',
      companies: 'Restauracje',
    },
    statuses: {
      active: 'Aktywna',
      redacted: 'Usunięta',
    },
    sca: {
      sandbox: 'Piaskownica 3DS2',
      live: '3DS2 produkcyjne',
      none: 'Brak 3DS2',
    },
    default_tag: 'Domyślna',
    actions: {
      make_default: 'Ustaw jako domyślną',
      check: 'Uruchom sprawdzenie…',
      sca_provision: 'Skonfiguruj 3DS2…',
      sca_manage: 'Rejestracja 3DS2…',
      redact: 'Usuń dane bramki',
    },
  },
  redact_confirm: {
    title: 'Usunąć dane {{gateway}}?',
    description:
      'Dane uwierzytelniające zostaną usunięte w Spreedly i nie da się ich przywrócić. {{count}} przypisana(-ych) restauracja(-i) nadal rozlicza się przez tę bramkę — dopóki jakaś jest przypisana, usunięcie jest odrzucane i musisz potwierdzić ponownie.',
    redact: 'Usuń dane',
    force_title: 'Mimo to usunąć dane {{gateway}}?',
    force_description:
      '{{count}} restauracja(-i) nadal jest przypisana do tej bramki. Usunięcie danych teraz zablokuje płatności, dopóki każda z nich nie zostanie przypisana do innej bramki. Tej operacji nie można cofnąć.',
    force_redact: 'Usuń mimo to',
  },
  companies: {
    title: 'Restauracje',
    description: 'Przez jaki procesor rozlicza się każda restauracja i jej przypisanie do bramki Spreedly.',
    empty: 'Brak restauracji',
    no_gateway: 'Brak',
    unassigned: 'Nieprzypisana',
    // The default gateway is assigned at creation and never fails the creation —
    // so a restaurant can end up unassigned with the reason only in the log.
    assignment_error_label: 'Automatyczne przypisanie nie powiodło się',
    assign: 'Przypisz',
    reassign: 'Zmień przypisanie',
    columns: {
      restaurant: 'Restauracja',
      primary_gateway: 'Główna bramka',
      spreedly: 'Bramka Spreedly',
    },
    switch_primary_to: 'Przełącz na {{gateway}}',
    assign_modal: {
      title: 'Przypisz {{company}} do bramki',
      assign: 'Przypisz',
      gateway: 'Bramka',
      make_primary: 'Ustaw też Spreedly jako główną bramkę',
      make_primary_hint: 'Obciążenia są kierowane przez Spreedly tylko wtedy, gdy jest ona główną bramką.',
    },
  },
  register_modal: {
    title: 'Zarejestruj bramkę',
    register: 'Zarejestruj',
    gateway_type: 'Typ bramki',
    gateway_type_placeholder: 'Przeszukaj katalog Spreedly…',
    auth_mode: 'Tryb uwierzytelniania',
    no_credentials: 'Ten typ bramki nie wymaga danych uwierzytelniających (piaskownica Spreedly).',
    description: 'Opis',
    description_placeholder: 'np. Acme Eats — Braintree EUR',
    acquirer_merchant_id: 'ID sprzedawcy acquirera',
    acquirer_hint: 'Opcjonalne — wymagane razem z MCC',
    mcc: 'MCC',
    mcc_hint: '4 cyfry, np. 5812',
    make_default: 'Użyj jako domyślnej dla partnera',
    make_default_hint:
      'Nowe restauracje partnera oraz te bez bramki płatności zostaną do niej przypisane. Nie zaznaczaj, jeśli to własny acquirer jednej restauracji.',
  },
  sca_modal: {
    title: 'Rejestracja 3DS2 — {{gateway}}',
    provision: 'Aprowizuj',
    irreversible_warning:
      'Nieodwracalne: ani profil sprzedawcy, ani dostawca SCA nie mogą zostać później zmienione ani usunięte. Błędny BIN acquirera ujawni się dopiero przy obciążeniu. Zweryfikuj każdą wartość z bankiem acquiringowym przed aprowizacją.',
    already_provisioned:
      'Już aprowizowane (token dostawcy {{token}}). Ponowna aprowizacja zwraca istniejącą rejestrację, chyba że włączono opcję Utwórz ponownie.',
    type: {
      label: 'Typ dostawcy',
      hint: 'Opcja „Testowy” symuluje wyniki uwierzytelniania i jest odrzucana na produkcji.',
      test: 'Testowy (piaskownica SCA)',
      live: 'Produkcyjny (Spreedly 3DS2 Global)',
    },
    country: {
      hint: 'Kraj, w którym bank rozliczeniowy zarejestrował tego partnera — niekoniecznie ten, w którym partner jest zarejestrowany. Dotyczy każdej sieci kart poniżej.',
      differs_warning:
        'To nie jest kraj partnera ({{country}}). Popraw, jeśli acquirer zarejestrował partnera gdzie indziej; w przeciwnym razie sprawdź to, ponieważ profilu handlowca nie można edytować po utworzeniu.',
    },
    network_placeholder: 'Sieć kart',
    add_network: 'Dodaj sieć kart',
    networks: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover',
      diners: 'Diners',
      jcb: 'JCB',
      dankort: 'Dankort',
      union_pay: 'UnionPay',
      cartes_bancaires: 'Cartes Bancaires',
    },
    fields: {
      acquirer_merchant_id: 'ID sprzedawcy acquirera',
      acquirer_bin: 'BIN nabywcy',
      mcc: 'MCC',
      merchant_name: 'Nazwa sprzedawcy',
      country_code: 'Kraj (ISO-2)',
      merchant_url: 'URL sprzedawcy',
    },
    recreate: {
      label: 'Odtwórz rejestrację',
      hint: 'Porzuca bieżący profil sprzedawcy i dostawcę SCA na zawsze i tworzy nowe.',
    },
  },
  check_modal: {
    title: 'Sprawdź bramkę — {{gateway}}',
    run: 'Uruchom sprawdzenie',
    done: 'Gotowe',
    failed: 'Nie udało się uruchomić sprawdzenia.',
    types: {
      verify: 'Weryfikuj (bez przelewu środków)',
      test_payment: 'Płatność testowa',
    },
    verify_unsupported: 'Ten typ bramki nie obsługuje weryfikacji — uruchom płatność testową.',
    test_payment_warning:
      'Rzeczywiste obciążenie zostaje wykonane na aktywnej bramce i natychmiast zwrócone. Na bramkach na rynkach SCA wydawca może odrzucić próbę bez 3DS — to nadal dowodzi, że dane dotarły do nabywcy.',
    amount: 'Kwota',
    amount_help: 'Między 1,00 a 5,00',
    check_passed: 'Sprawdzenie zaliczone',
    check_failed: 'Sprawdzenie nieudane — zobacz kroki poniżej',
    legs: {
      verify: 'Weryfikacja',
      purchase: 'Obciążenie',
      credit: 'Zwrot',
    },
    leg_passed: 'Zaliczono',
    leg_failed: 'Nieudane',
  },
  card_fields: {
    script_failed: 'Nie udało się załadować skryptu Spreedly. Sprawdź sieć i spróbuj ponownie.',
    full_name: 'Imię i nazwisko posiadacza karty',
    number: 'Numer karty',
    expiry: 'Data ważności',
    cvv: 'CVV',
  },
};
